import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { RepliesRelayResponseDto, ReplyRelayResponseDto } from '@diritto/common/relay/dtos/reply-relay.dtos';
import { ReplyOrder } from '@diritto/common/reply/constants';
import { Http } from '@diritto/common/utils/requester/http';
import { generateUrl } from '@diritto/common/utils/urls';

export class RelayReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async findAll(categoryIds?: number[], paginator?: BasePaginatorDto) {
    const res = await this.http.get<RepliesRelayResponseDto>(
      generateUrl(`${this.url}/relay/replies`, {
        categoryIds,
        ...paginator,
      }),
    );
    return res.data;
  }

  async getReply(replyId: number) {
    const res = await this.http.get<ReplyRelayResponseDto>(`${this.url}/relay/replies/${replyId}`);
    return res.data;
  }

  async getReReply(replyId: number, orderBy: ReplyOrder, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RepliesRelayResponseDto>(`${this.url}/relay/replies/${replyId}/replies`, {
      params: {
        orderBy,
        ...paginator,
      },
    });
    return res.data;
  }

  async getContentReplies(contentId: number, orderBy: ReplyOrder, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RepliesRelayResponseDto>(`${this.url}/relay/replies/contents/${contentId}`, {
      params: {
        orderBy,
        ...paginator,
      },
    });
    return res.data;
  }

  async getEpisodeReplies(episodeId: number, orderBy: ReplyOrder, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RepliesRelayResponseDto>(`${this.url}/relay/replies/episodes/${episodeId}`, {
      params: {
        orderBy,
        ...paginator,
      },
    });
    return res.data;
  }

  async getProfileReplies(profileId: number, orderBy: ReplyOrder, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RepliesRelayResponseDto>(`${this.url}/relay/replies/profiles/${profileId}`, {
      params: {
        orderBy,
        ...paginator,
      },
    });
    return res.data;
  }
}
